var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 15.5938C7.3125 14.9062 8 13.9792 8.8125 12.8125C9.625 11.6667 10.3542 10.4792 11 9.25C11.625 8.02083 11.9583 6.9375 12 6C11.9583 4.29167 11.375 2.875 10.25 1.75C9.125 0.625 7.70833 0.0416667 6 0C4.29167 0.0416667 2.875 0.625 1.75 1.75C0.625 2.875 0.0416667 4.29167 0 6C0.0416667 6.9375 0.375 8.02083 1 9.25C1.64583 10.4792 2.375 11.6667 3.1875 12.8125C4 13.9792 4.6875 14.9062 5.25 15.5938C5.45833 15.8438 5.70833 15.9688 6 15.9688C6.29167 15.9688 6.54167 15.8438 6.75 15.5938ZM6 4C6.75 4.02083 7.32292 4.35417 7.71875 5C8.09375 5.66667 8.09375 6.33333 7.71875 7C7.32292 7.64583 6.75 7.97917 6 8C5.25 7.97917 4.67708 7.64583 4.28125 7C3.90625 6.33333 3.90625 5.66667 4.28125 5C4.67708 4.35417 5.25 4.02083 6 4Z",
    fill: "#45474C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGps);
export default __webpack_public_path__ + "static/media/gps.cfaf4688fe8eb033ab0ca1522cf1c93d.svg";
export { ForwardRef as ReactComponent };